module.exports = "/assets/data/7f51ddc7e50b183a1b43dde4171ce0b3-WR3.data.json";